import { Divider, makeStyles, Tab } from '@material-ui/core';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Parameters from './Parameters';

const useStyles = makeStyles({
  tabPanel: {
    paddingTop: '5em',
    paddingLeft: '0',
  },
});

const UserProfile: React.FC = () => {
  const TAB_ID = {
    PROFILE: 'PROFILE',
    CENTERS: 'CENTERS',
    PARAMETERS: 'PARAMETERS',
  };
  const { t } = useTranslation();
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(TAB_ID.PARAMETERS);

  const handleChangeTab = (event: any, newValue: string) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <TabContext value={selectedTab}>
        <TabList value={selectedTab} onChange={handleChangeTab} indicatorColor="primary" textColor="primary">
          <Tab value={TAB_ID.PROFILE} label={t('userProfile.tabs.profile')} disabled />
          <Tab value={TAB_ID.CENTERS} label={t('userProfile.tabs.centers')} disabled />
          <Tab value={TAB_ID.PARAMETERS} label={t('userProfile.tabs.parameters')} />
        </TabList>
        <Divider />
        <TabPanel className={classes.tabPanel} value={TAB_ID.PROFILE}></TabPanel>

        <TabPanel className={classes.tabPanel} value={TAB_ID.CENTERS}></TabPanel>

        <TabPanel className={classes.tabPanel} value={TAB_ID.PARAMETERS}>
          <Parameters />
        </TabPanel>
      </TabContext>
    </>
  );
};

export default UserProfile;
